import React from 'react';
import { Card, Tabs } from 'antd';
import {
    SyncOutlined, AlertOutlined, AppstoreOutlined, ClockCircleOutlined
} from '@ant-design/icons';
import ChungTab from './ChungTab';
import RuleCheckTab from './RuleCheckTab';
import HourlyRulesTab from './HourlyRulesTab';
import MayThucHienTab from './MayThucHienTab';

const HisSyncTab: React.FC = () => {
    return (
        <Card styles={{ body: { padding: 0 } }} variant="borderless">
            <Tabs
                defaultActiveKey="chung"
                size="large"
                items={[
                    {
                        key: 'chung',
                        label: (
                            <span>
                                <SyncOutlined /> Chung
                            </span>
                        ),
                        children: (
                            <div style={{ padding: 16 }}>
                                <ChungTab />
                            </div>
                        ),
                    },
                    {
                        key: 'rule-check',
                        label: (
                            <span>
                                <AlertOutlined /> Rule Check
                            </span>
                        ),
                        children: (
                            <div style={{ padding: 16 }}>
                                <RuleCheckTab />
                            </div>
                        ),
                    },
                    {
                        key: 'hourly-rules',
                        label: (
                            <span>
                                <ClockCircleOutlined /> Rules Theo giờ
                            </span>
                        ),
                        children: (
                            <div style={{ padding: 16 }}>
                                <HourlyRulesTab />
                            </div>
                        ),
                    },
                    {
                        key: 'may-thuc-hien',
                        label: (
                            <span>
                                <AppstoreOutlined /> Máy thực hiện
                            </span>
                        ),
                        children: (
                            <div style={{ padding: 16 }}>
                                <MayThucHienTab />
                            </div>
                        ),
                    },
                ]}
            />
        </Card>
    );
};

export default HisSyncTab;
